import { jsx as C } from "react/jsx-runtime";
function i(r) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M20.25 11C20.25 5.89137 16.1086 1.75 11 1.75C5.89137 1.75 1.75 5.89137 1.75 11C1.75 16.1086 5.89137 20.25 11 20.25C16.1086 20.25 20.25 16.1086 20.25 11ZM13.4697 7.46973C13.7626 7.17683 14.2374 7.17683 14.5303 7.46973C14.8232 7.76262 14.8232 8.23738 14.5303 8.53027L12.0605 11L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L11 12.0605L8.53027 14.5303C8.23738 14.8232 7.76262 14.8232 7.46973 14.5303C7.17683 14.2374 7.17683 13.7626 7.46973 13.4697L9.93945 11L7.46973 8.53027C7.17683 8.23738 7.17683 7.76262 7.46973 7.46973C7.76262 7.17683 8.23738 7.17683 8.53027 7.46973L11 9.93945L13.4697 7.46973ZM21.75 11C21.75 16.9371 16.9371 21.75 11 21.75C5.06294 21.75 0.25 16.9371 0.25 11C0.25 5.06294 5.06294 0.25 11 0.25C16.9371 0.25 21.75 5.06294 21.75 11Z",
          fill: "rgb(var(--text-primary))"
        }
      )
    }
  );
}
export {
  i as XCircleIcon
};
